import React from 'react'
import { HelmetInfo } from '../../../types/helmetLookup'

interface HelmetInfoCardProps {
  helmetInfo: HelmetInfo
}

const HelmetInfoCard: React.FC<HelmetInfoCardProps> = ({ helmetInfo }) => {
  return (
    <div className="bg-success/10 border-l-4 border-success p-3 sm:p-4 lg:p-6 rounded-lg w-full">
      <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-3 mb-3 sm:mb-4">
        <div className="bg-success text-white rounded-full w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center font-bold text-xs sm:text-sm lg:text-base flex-shrink-0">2</div>
        <h3 className="text-base sm:text-lg lg:text-xl font-heading font-bold text-riddell-black">HELMET INFORMATION</h3>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-2 sm:gap-3 text-xs sm:text-sm w-full">
        <div className="bg-white p-2 sm:p-3 rounded-md shadow-sm w-full">
          <span className="block text-xs font-bold text-riddell-black uppercase tracking-wide mb-0.5">Source Org</span>
          <span className="text-sm sm:text-base font-medium text-riddell-black break-words leading-tight">{helmetInfo.sourceOrgName}</span>
        </div>
        <div className="bg-white p-2 sm:p-3 rounded-md shadow-sm w-full">
          <span className="block text-xs font-bold text-riddell-black uppercase tracking-wide mb-0.5">RFID Label</span>
          <span className="text-sm sm:text-base font-bold text-riddell-red">{helmetInfo.helmetRFIDLabel || 'N/A'}</span>
        </div>
        <div className="bg-white p-2 sm:p-3 rounded-md shadow-sm w-full">
          <span className="block text-xs font-bold text-riddell-black uppercase tracking-wide mb-0.5">RFID Barcode</span>
          <span className="text-sm sm:text-base font-medium text-riddell-black break-all leading-tight">{helmetInfo.rfidBarcode || 'N/A'}</span>
        </div>
        <div className="bg-white p-2 sm:p-3 rounded-md shadow-sm w-full">
          <span className="block text-xs font-bold text-riddell-black uppercase tracking-wide mb-0.5">Player Unit S/N</span>
          <span className="text-sm sm:text-base font-medium text-riddell-black break-all leading-tight">{helmetInfo.playerUnitSerialString}</span>
        </div>
        {helmetInfo.currentPlayer && (
          <div className="bg-white p-2 sm:p-3 rounded-md shadow-sm w-full">
            <span className="block text-xs font-bold text-riddell-black uppercase tracking-wide mb-0.5">Player</span>
            <span className="text-sm sm:text-base font-medium text-riddell-black break-words leading-tight">
              {helmetInfo.currentPlayer.playerName} {helmetInfo.currentPlayer.jerseyNumber && `(#${helmetInfo.currentPlayer.jerseyNumber})`}
            </span>
          </div>
        )}
        {helmetInfo.rfidCode && (
          <div className="bg-white p-2 sm:p-3 rounded-md shadow-sm w-full">
            <span className="block text-xs font-bold text-riddell-black uppercase tracking-wide mb-0.5">RFID Code</span>
            <span className="text-sm sm:text-base font-medium text-riddell-black break-all leading-tight">{helmetInfo.rfidCode}</span>
          </div>
        )}
      </div>
      {helmetInfo.features?.toLowerCase() === 'convertible' && (
        <div className="mt-4 p-3 sm:p-4 bg-warning/10 border border-warning/30 rounded-lg" role="alert">
          <p className="text-sm sm:text-base font-bold text-warning uppercase tracking-wide mb-1">Convertible Helmet</p>
          <p className="text-sm text-riddell-black">This is a Convertible helmet. The target organization must have a matching "RIDDELL {helmetInfo.helmetHatSize}" player to receive this helmet.</p>
        </div>
      )}
    </div>
  )
}

export default HelmetInfoCard
